/**
 * 「用此提示词重新创作 / 出全渠道套图」回填时该给文案框什么(2026-09-01)。
 *
 * ═══ 病根:回填过一次拼装串,追加段就开始滚雪球 ═══════════════════════════════
 * `task.rawPrompt` 是提交时 `buildRawPrompt` 拼好的**成串**:用户原文之后追加了
 * 【产品】【画幅构图】【风格】【字体风格】若干段。详情页 recreate 此前把它整个
 * 灌回文案框(FreeCreateBody `form.setPrompt`),再提交时 buildRawPrompt **无条件**
 * 再追加一次画幅段 —— 每转一轮多叠一层。实锤单(0901 爱民):首单原文 744+画幅段
 * 30=774,recreate 回填 774 再提交 =804,【画幅构图】出现两遍。
 * 产品/风格/字体段不滚是因为回填后选择器为空、不再追加(旧段只是滞留在文本里);
 * 唯独画幅段永远有值、永远追加。FinalPromptFold 给画幅段标 noEject 防的正是这件事,
 * recreate 是绕过它的另一扇门。
 *
 * ═══ 修法:优先用户原文,老单剥追加段兜底 ═══════════════════════════════════
 * 新单 payload 里另存了 `content.userPrompt`(用户亲手打的字),回填直接用;
 * 老单没存这份 → `recoverUserPrompt` 从拼装串里把追加段剥回去。
 */

/** 提交时追加、且**多行**的三段 —— 从它们的首行起整个尾巴都是系统拼的。 */
const TAIL_SECTION_RE = /^【(产品|风格|字体风格)】/;
/** 画幅段:单行(`ratioCompositionPhrase` 输出无换行),可能因历史叠加散落在文中任意位置。 */
const RATIO_LINE_RE = /^【画幅构图】/;

/**
 * 从拼装后的 rawPrompt 尽力恢复用户原文(老单兜底;详情 DTO 的 rawPrompt 已剥
 * [AI-OPTIMIZED] 哨兵,AI 优化的老单恢复出来的是归整稿+原话段 —— 比整串仍严格更好)。
 *
 * 两步,顺序有讲究:
 * 1. 删**所有**【画幅构图】行 —— 它是单行段,且历史叠加 bug 会让它出现在用户文本
 *    中间(recreate 后用户又在下面补了字的形状),只切尾巴洗不掉;
 * 2. 从第一个多行追加段(【产品】/【风格】/【字体风格】)起截断尾巴。
 *
 * ★已知边界:用户原文自己顶格写了「【风格】…」这类行会被误剥 —— 只影响回填的
 * 便利文本,不影响任何已提交任务;新单都有 userPrompt,不走这条路。
 */
export function recoverUserPrompt(rawPrompt: string | null | undefined): string {
  if (!rawPrompt) return "";
  const lines = rawPrompt.split("\n").filter((line) => !RATIO_LINE_RE.test(line));
  const tailStart = lines.findIndex((line) => TAIL_SECTION_RE.test(line));
  return (tailStart === -1 ? lines : lines.slice(0, tailStart)).join("\n").trim();
}

/** 回填口径单源:新单用存下来的原文,老单走恢复。 */
export function promptForRecreate(task: {
  userPrompt?: string | null;
  rawPrompt?: string | null;
}): string {
  return task.userPrompt?.trim() || recoverUserPrompt(task.rawPrompt);
}
